export const TICKET_CREATE_RESET = 'TICKET_CREATE_RESET'
export const TICKET_CREATE_SET_CREATED = 'TICKET_CREATE_SET_CREATED'
export const TICKET_CREATE_SET_ERROR = 'TICKET_CREATE_SET_ERROR'
export const TICKET_CREATE_SET_VIOLATIONS = 'TICKET_CREATE_SET_VIOLATIONS'
export const TICKET_CREATE_TOGGLE_LOADING = 'TICKET_CREATE_TOGGLE_LOADING'
